import {connect} from 'react-redux';
import TagPanel from './TagPanel.jsx';
import {
  handleTagAddClick,
  handleTagCancelClick,
  handleTagChange,
  handleTagNameChange,
  handleTagRemoveClick,
  handleTagSaveClick
} from './actions';

const mapStateToProps = state => ({
  canAssignTag: state.tournament.general.canAssignTag,
  canDeleteTag: state.tournament.general.canDeleteTag,
  isAddingTag: state.tournament.general.isAddingTag,
  tags: state.tournament.general.tags,
  tournamentTags: state.tournament.general.tournamentTags
});

const mapDispatchToProps = dispatch => ({
  onAddTagClick: () => dispatch(handleTagAddClick()),
  onCancelClick: () => dispatch(handleTagCancelClick()),
  onRemoveTagClick: data => dispatch(handleTagRemoveClick(data)),
  onSaveClick: id => dispatch(handleTagSaveClick(id)),
  onTagChange: data => dispatch(handleTagChange(data)),
  onTagNameChange: data => dispatch(handleTagNameChange(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(TagPanel);



// WEBPACK FOOTER //
// ./src/features/tournament/general/TagPanelContainer.jsx